import React from 'react';
import {observer} from 'mobx-react';
import {Route, Switch} from 'react-router-dom';
import {tagStore} from "../../store/TagStore";
import TagView from "./TagView";
import TagMediaViewFrame from "../media/TagMediaViewFrame";
import {TAG_TYPE} from "../../const/AppConst";

@observer
class TagViewFrame extends React.Component {

    componentDidMount() {
        tagStore.type = TAG_TYPE[this.props.match.params.type];
        tagStore.debounceRefresh();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.match.params.type !== this.props.match.params.type) {
            tagStore.type = TAG_TYPE[this.props.match.params.type];
            tagStore.debounceRefresh();
        }
    }

    componentWillUnmount() {
        tagStore.clear();
    }

    render() {
        return (
            <Switch>
                <Route path="/main/tag/:type/:tagId" component={TagMediaViewFrame}/>
                <Route path="/main/tag/:type" component={TagView}/>
            </Switch>
        );

    }
}

export default TagViewFrame;
